import TextField, { TextFieldProps } from './TextField';

export function PasswordField({ ...rest }: TextFieldProps) {
  const isHidden = rest.value === '*****';

  const value = isHidden ? '' : rest.value;
  const placeholder = isHidden ? 'hidden' : undefined;

  return (
    <TextField
      {...rest}
      InputLabelProps={{ shrink: true }}
      placeholder={placeholder}
      value={value}
    />
  );
}
